'use client';

import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

const customMarkerIcon = new L.DivIcon({
  className: "custom-icon",
  html: `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" width="60" height="60">
      <path fill="#22C55E" fill-rule="evenodd" d="M11.291 21.706 12 21l-.709.706zM12 21l.708.706a1 1 0 0 1-1.417 0l-.006-.007-.017-.017-.062-.063a49.562 49.562 0 0 1-2.456-2.908c-.892-1.15-1.804-2.45-2.497-3.734C4.535 12.612 4 11.248 4 10c0-4.539 3.592-8 8-8 4.408 0 8 3.461 8 8 0 1.248-.535 2.612-1.213 3.87-.693 1.286-1.604 2.585-2.497 3.735a49.583 49.583 0 0 1-3.496 4.014L12 21zm0-8a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" clip-rule="evenodd"></path>
    </svg>
  `,
  iconSize: [60, 60],
  iconAnchor: [30, 60],
});

export default function customMarkerIconDesktop() {
  return (
    <MapContainer
    center={[51.3655, 0.21855]}
    zoom={12}
    className="absolute inset-0 z-0"
    style={{ height: "100%", width: "100%" }}
    zoomControl={false} // Disable zoom controls
    scrollWheelZoom={false} // Disable mouse wheel zoom
    doubleClickZoom={false} // Disable double-click zoom
    touchZoom={false} // Disable touch zoom
  >
      <TileLayer
        url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
        attribution='&copy; OpenStreetMap contributors &copy; CARTO'
      />

      <Marker position={[51.39700288145344, 0.029697105447115964]} icon={customMarkerIcon}>
        <Popup><b>50D Homesdale Rd, Bromley BR2 9LD, United Kingdom</b></Popup>
      </Marker>
      <Marker position={[51.331935995002695, 0.2830028918458493]} icon={customMarkerIcon}>
        <Popup><b>West Kingsdown Address</b></Popup>
      </Marker>
    </MapContainer>
  );
}
